import React, { memo, useMemo } from "react";
import classes from "./BreadCrumbs.scss";
import classNames from "classnames";
import _ from "lodash";
import {
  Button,
  Dropdown,
  DropdownMenu,
  ButtonDisclosure,
} from "@toddle-edu/ds-web";
import ConditionalWrapper from "Utils/ConditionalWrapper";

const TEST_ID_PREFIX = "courseStandards-breadCrumbs";

const BreadCrumbs = props => {
  const {
    standardEdges,
    setStandardSetId,
    standardSetId,
    title,
    label,
  } = props;

  const options = useMemo(
    () =>
      _.map(standardEdges, ({ standardSet }) => ({
        key: standardSet.id,
        label: standardSet.title,
      })),
    [standardEdges]
  );

  const handleSelect = ({ key }) => {
    setStandardSetId(key);
  };

  const ButtonComponentToRender =
    _.size(options) > 1 ? ButtonDisclosure : Button;

  return (
    <div className={classes.container}>
      <Button
        testId={`${TEST_ID_PREFIX}-sets`}
        type="inline"
        variant="neutral"
        size="small"
        className={classes.button}
        onClick={() => setStandardSetId(null)}
      >
        {label}
      </Button>

      <div className={classNames("text-label-s", classes.interactiveSecondary)}>
        /
      </div>
      <ConditionalWrapper
        type="wrapperAsElement"
        condition={_.size(options) > 1}
        wrapper={
          <Dropdown
            overlay={
              <DropdownMenu
                options={options}
                testId={TEST_ID_PREFIX}
                showSearch
                showSelection
                onClick={handleSelect}
                value={standardSetId}
                isSearchEnabled
              />
            }
          />
        }
      >
        <ButtonComponentToRender
          testId={`${TEST_ID_PREFIX}-setName`}
          type="inline"
          variant="progressive"
          size="small"
          className={classes.button}
        >
          {title}
        </ButtonComponentToRender>
      </ConditionalWrapper>
    </div>
  );
};

export default memo(BreadCrumbs);
